import {CommonModule} from '@angular/common';
import {Component, computed, effect, ElementRef, inject, ViewChild} from '@angular/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {RouterOutlet} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import QRCode from 'qrcode';
import {TimelineService} from 'src/infrastructure/timeline/timeline.service';
import {AuthWrapperComponent} from 'src/shared/auth-wrapper/auth-wrapper.component';

@Component({
    selector: 'app-public-timeline-sharing',
    templateUrl: './public-timeline-sharing.component.html',
    styleUrls: ['./public-timeline-sharing.component.scss'],
    standalone: true,
    imports: [
        RouterOutlet,
        TranslateModule,
        AuthWrapperComponent,
        MatProgressSpinnerModule,
        CommonModule
    ]
})
export class PublicTimelineSharingComponent
{
    @ViewChild('qrCode') public qrCode?: ElementRef;

    private readonly timelineService = inject(TimelineService);

    public readonly loadingQrCode = computed(() => this.timelineService.loading());

    public constructor()
    {
        effect(() =>
        {
            if (!!this.timelineService.qrCodeToken())
            {
                QRCode.toCanvas(this.qrCode.nativeElement, this.timelineService.qrCodeToken(), {width: 292, margin: 2});

                this.timelineService.checkIfQrCodeIsValid();
            }

            
            if (!this.timelineService.qrCodeToken() && !this.loadingQrCode())
            {
                this.timelineService.generateQrCodeToken();
            }
        }, {allowSignalWrites: true});
    }
}

